import colors from '../../../../shared/theme/colors';
import fonts from '../../../../shared/theme/fonts';
import metrics from '../../../../shared/theme/metrics';
import { Fonts, Colors } from '../../../../shared/theme';

export default {
  background: {
    backgroundColor: colors.outWhite,
    height: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex'
  },
  container: {
    width: '320px',
    backgroundColor: colors.white,
    boxShadow: 'rgba(0,0,0,0.2) 0px 2px 4px',
    borderRadius: '10px',
    justifyContent: 'center',
    padding: '40px 20px 40px 20px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column'
  },
  image: {
    width: '234px',
    height: '224px',
    marginBottom: metrics.baseMargin * 1.5,
    alignSelf: 'center'
  },
  successIconImage: {
    fontSize: Fonts.size.text70,
    color: Colors.successGreen,
    marginBottom: '40px'
  },
  title: {
    ...fonts.style.textHeaderKanitSemiBold20,
    color: colors.font.primary.fakeBlack,
    whiteSpace: 'pre-line',
    marginBottom: metrics.baseMargin
  },
  description: {
    ...fonts.style.textContentMedium,
    whiteSpace: 'pre-line'
  }
};
